import React from 'react';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    id?: string;
    'data-testid'?: string;
    variant?: 'boxed' | 'inline';
}

export const TextArea: React.FC<TextAreaProps> = ({ label, id, className = '', 'data-testid': dataTestId, variant = 'boxed', ...props }) => {
    if (variant === 'inline') {
        return (
            <textarea
                id={id}
                data-testid={dataTestId}
                className={`w-full bg-transparent border-0 p-0 text-compact text-primary-1225 focus:outline-none disabled:text-content-secondary disabled:cursor-not-allowed leading-relaxed placeholder:text-primary-600 resize-none touch-target field-text-mobile ${className}`}
                {...props}
            />
        );
    }

    return (
        <div className="flex flex-col gap-s">
            {label && (
                <label htmlFor={id} className="text-compact font-medium text-primary-1100">
                    {label}
                </label>
            )}
            <textarea
                id={id}
                data-testid={dataTestId}
                className={`px-m py-s rounded-md border border-line bg-primary-50 text-primary-1225 text-compact placeholder:text-primary-600 focus:outline-none focus:border-focus focus:ring-4 focus:ring-focus-ring transition-colors resize-none disabled:bg-primary-200 disabled:text-content-secondary disabled:border-line disabled:cursor-not-allowed field-text-mobile ${className}`}
                {...props}
            />
        </div>
    );
};
